import { reusableItems } from 'data/mock-data';

const mock = () => ({
  data: { reusableOrderDetails: reusableItems },
});

export default mock;
